import { Button, Card, Space, Table, Typography } from 'antd';
import React, { useState } from 'react';

import { DetailModal } from './components/DetailModal';
import { EditModal } from './components/EditModal';
import {
  DUMMY_VENUE_DETAIL,
  DUMMY_VENUE_EDIT_VALUES,
  DUMMY_VENUE_LIST,
  VENUE_EDIT_FORM_DEFAULT_VALUES,
} from './constants';
import { getVenueTableColumns } from './helpers';
import type { VenueData, VenueDetailData, VenueEditFormValues } from './types';

const { Title } = Typography;

export const VenueManagement = () => {
  const [viewingVenue, setViewingVenue] = useState<VenueDetailData | undefined>(
    undefined
  );
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [editingVenue, setEditingVenue] = useState<VenueEditFormValues>(
    VENUE_EDIT_FORM_DEFAULT_VALUES
  );
  const [openEditModal, setOpenEditModal] = useState(false);

  const onView = (record: VenueData) => {
    console.log('onView:', record);
    // TODO: 這裡打API獲取欲查看的活動空間資料
    setViewingVenue(DUMMY_VENUE_DETAIL);
    setOpenDetailModal(true);
  };
  const onEdit = (record: VenueData) => {
    console.log('onEdit:', record);
    // TODO: 這裡打API獲取欲編輯的活動空間資料
    setEditingVenue(DUMMY_VENUE_EDIT_VALUES);
    setOpenEditModal(true);
  };
  const onDelete = (record: VenueData) => {
    console.log('onDelete:', record);
  };

  const closeDetailModal = () => {
    setViewingVenue(undefined);
    setOpenDetailModal(false);
  };

  const closeEditModal = () => {
    setEditingVenue(VENUE_EDIT_FORM_DEFAULT_VALUES);
    setOpenEditModal(false);
  };

  const handleEditVenueFormSubmit = (formValues: VenueEditFormValues) => {
    console.log('formValues:', formValues);
    // TODO: 提交邏輯，待做
  };

  const columns = getVenueTableColumns({
    onView,
    onEdit,
    onDelete,
  });

  return (
    <>
      <Space direction="vertical" className="w-full">
        <Button onClick={() => setOpenEditModal(true)}>新增活動空間</Button>
        <Card>
          <Title level={5}>空間清單</Title>
          <Table
            bordered
            rowKey="_id"
            scroll={{ x: 'max-content' }}
            columns={columns}
            dataSource={DUMMY_VENUE_LIST}
          />
        </Card>
      </Space>

      <DetailModal
        open={openDetailModal}
        onClose={closeDetailModal}
        venue={viewingVenue}
      />

      <EditModal
        open={openEditModal}
        onClose={closeEditModal}
        editingVenue={editingVenue}
        onSubmit={handleEditVenueFormSubmit}
      />
    </>
  );
};
